module.exports = __webpack_public_path__ + "static/media/hytte.02258724.svg";